export const ENV_API = process.env.ENV_API;
export const HOST_API = process.env.HOST_API;
export const APPS_URL = process.env.APPS_URL;
export const v1 = "v1/";
export const HOST_API_V1 = HOST_API + v1;
